import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute('/_secured/ai-hub/$chatId/')({
  validateSearch: z.object({
    voiceMode: z.boolean().optional(),
  }),
  loader: async ({ context }) => {
    await context.getInstance('i18n', '@mint-lib/formatting-hooks');
  },
  head: ({ params }) => ({
    meta: [
      {
        title: `AI Hub – Chat ${params.chatId} | MINT`,
      },
    ],
  }),
});
